import axios from "axios";
import store from "../redux/store";
import { getClientID, getCommandByIndex, getFilters, getSN, getURL } from "../redux/selectors";

const execBatch = async (tabID) => {
  const state = store.getState();
  const url = getURL(state);
  const clientID = getClientID(state);
  const serialnumber = getSN(state);
  const command = getCommandByIndex(state, tabID);
  const object = `${serialnumber}/object=${command}`;
  const filters = getFilters(state, tabID);
  const filterText = filters?.text ?? "";

  return await axios
    .post(`${process.env.REACT_APP_BACKEND_DOMAIN}/d1services`, {
      url,
      data: {
        service: "execBatch",
        clientID,
        object,
        filters: filterText,
        appID: process.env.REACT_APP_SOFTONE_APPID,
      },
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default execBatch;
